import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useExperimentSelector } from '../../../store/selectors/experimentSelector'
import { useCommonApi } from '../../../store/api/hooks/commonApiHook'
import { useExperimentApi } from '../../../store/api/hooks/experimentApiHook'
import { useFpLoader } from '../../../store/api/hooks/fpLoaderHook'
import { useDialog } from '../../../store/api/hooks/dialogHook'
import { useMeasurementConfigure } from '../../../_common/hook/useMeasurementConfigure'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { BusinessFunctionDataType, DistributionColumnNameType } from '../../../_config/types'
import { filteredOption, getSelectedOption, makeUniqueOptionArray, processDataColumnResponse, sortOptions, trackEvent } from '../../../_common/functions'
import { cellRenderer } from '../../../components/cellRenderer'
import { ErrorResponse } from '../../../store/api/apiTypes'
import toast from 'react-hot-toast'
import { URLS } from '../../../_config'
import Container from '../../../elements/Container'
import MatchingParameter from './MatchingParameter'
import Text from '../../../elements/Typo/Text'
import Dropdown from '../../../elements/Form/dropdown'
import CommonInputText from '../../../components/commonInputText'
import CustomAgGrid from '../../../components/CustomAgGrid'
import Button from '../../../elements/button'
import Loader from '../../../components/loader'
import MeasurementSuccessModal from './modal/measurementSuccess.modal'
import FieldValidation from '../../../components/groupConfigComponents/fieldValidation'
import GroupConfigHeading from '../../CreateExperiment/components/groupConfigHeading'
import { EXPERIMENT_TYPES } from '../../../_common/constant'
import i18n from '../../../i18n'
import P from '../../../elements/Typo/P'
import { useConfirmDialog } from '../../../components/confirmDialog'
import moment from 'moment'
import Md from '../../../components/testOpsGenie/components/md'

const GroupName = (group: any, i: number, control: any, trigger: any, errors: any, t: any) => {
    return (
        <div className="col-span-4 bg-[#f4f4f4] border border-[#d4d4d4] rounded-[0.3rem] pl-[0.417rem] grid grid-cols-2 gap-2">
            <div className="flex items-center ">
                <Text size="md" className="leading-none font-semibold">
                    {group.name}
                </Text>
            </div>
            <div className="flex items-center  ">
                <Controller
                    name={`groupConfigs[${i}].action`}
                    control={control}
                    rules={{
                        required: t('Please provide action'),
                        minLength: {
                            value: 2,
                            message: t('Action should be atleast 2 character'),
                        },
                        maxLength: {
                            value: 1000,
                            message: t('Maximum 1000 character allowed'),
                        },
                        validate: {
                            notOnlyNumbers: (value) => {
                                return /^(?=.*[a-zA-Z])[^]*$/.test(value) ? true : t('Action should not contain only numerical  or only special character.')
                            },
                        },
                    }}
                    render={({ field: { value, onChange } }) => (
                        <CommonInputText
                            multiline={true}
                            value={value}
                            onChange={(e) => {
                                onChange(e)
                                trigger(`groupConfigs[${i}].action`)
                            }}
                            placeholder={t('Action')}
                            error={errors?.groupConfigs?.[i]?.action?.message as string}
                        />
                    )}
                />
            </div>
        </div>
    )
}

const isControl = (control: any, i: number, groupConfigsWatch: any, groupConfigUpdate: any) => {
    return (
        <div className="col-span-2 flex items-center justify-center bg-[#f4f4f4] border border-[#d4d4d4] rounded-[0.3rem] p-[0.417rem]">
            <Controller
                name={`groupConfigs[${i}].isControl` as 'groupConfigs.0.isControl'}
                control={control}
                render={({ field: { name, value } }) => (
                    <input
                        name={name}
                        type="checkbox"
                        className="toggle !border-0 text-[#222222] toggle-primary"
                        checked={value}
                        onChange={(e) => {
                            if (e.target.checked) {
                                groupConfigsWatch.map((_group: any, _index: number) => {
                                    groupConfigUpdate(_index, { ..._group, isControl: i == _index })
                                })
                                trackEvent('measurement_configure_group_control_toggled', { experiment_literal: undefined })
                            }
                        }}
                    />
                )}
            />
        </div>
    )
}

export const RCTDataTable = (dataTableGrid: any, rowData: any, columnDefs: any) => {
    return (
        <div className="my-4">
            <CustomAgGrid
                key={'mmm_123_123_' + i18n.language}
                gridRef={dataTableGrid}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={{ sortable: true, filter: true }}
                theme="light"
                pagination={false}
                paginationPageSize={5} // Must match one of the values below
                paginationPageSizeSelector={[5, 10, 20, 50]} // Ensure 5 is included
                style={{ height: 350, width: '100%' }}
                gridId="summmyGrid"
                rowHeight={50}
                alternativeRowColor={'#E5B61112'}
            />
        </div>
    )
}

export const DateFrequency = (control: any, trigger: any, metrix: any, t: any, required: boolean = true) => {
    const allContinuousKpis: boolean = metrix.length > 0 && metrix?.every((kpi: any) => kpi.kpi_type?.toLowerCase() === 'continuous' && !kpi.is_custom)
    if (metrix?.length) {
        if (metrix[0].literral_value == 'Total Distribution') {
            return null
        }
    } else {
        return null
    }

    return (
        <div className="flex items-center gap-2">
            <div>
                <Controller
                    name="frequency"
                    control={control}
                    rules={{
                        required: required ? t('Please select frequency') : false,
                    }}
                    render={({ field: { value, onChange } }) => (
                        <>
                            <input
                                name="date-type"
                                type="radio"
                                id="m-date-daily"
                                className="peer hidden"
                                value="daily"
                                checked={'daily' == value}
                                disabled={!required}
                                onChange={(v) => {
                                    onChange(v)
                                    trigger('frequency')
                                    trackEvent('measurement_configure_frequency_selected', { experiment_literal: undefined, frequency: 'daily' })
                                }}
                            />
                            <label
                                htmlFor="m-date-daily"
                                className={`cursor-default block leading-[1.667rem] text-[0.667rem] font-semibold px-1 rounded-[0.333rem]  peer-checked:bg-primary ${required ? 'text-gray-900 cursor-pointer' : 'text-gray-500'}`}
                            >
                                {t('Daily')}
                            </label>
                        </>
                    )}
                />
            </div>
            <div>
                <Controller
                    name="frequency"
                    control={control}
                    rules={{
                        required: required ? t('Please select') : false,
                    }}
                    render={({ field: { value, onChange } }) => (
                        <>
                            <input
                                name="date-type"
                                type="radio"
                                id="m-date-weekly"
                                className="peer hidden"
                                value="weekly"
                                disabled={!(required && allContinuousKpis)}
                                checked={'weekly' == value}
                                onChange={(v) => {
                                    onChange(v)
                                    trigger('frequency')
                                    trackEvent('measurement_configure_frequency_selected', { experiment_literal: undefined, frequency: 'weekly' })
                                }}
                            />
                            <label
                                htmlFor="m-date-weekly"
                                className={`group relative cursor-default block leading-[1.667rem] text-[0.667rem] font-semibold px-1 rounded-[0.333rem]  peer-checked:bg-primary ${required && allContinuousKpis ? 'text-gray-900 cursor-pointer' : 'text-gray-500'}`}
                            >
                                {t('Weekly')}{' '}
                            </label>
                        </>
                    )}
                />
            </div>
            <div>
                <Controller
                    name="frequency"
                    control={control}
                    rules={{
                        required: required ? t('Please select') : false,
                    }}
                    render={({ field: { value, onChange } }) => (
                        <>
                            <input
                                name="date-type"
                                type="radio"
                                id="m-date-monthly"
                                className="peer hidden"
                                value="monthly"
                                checked={'monthly' == value}
                                disabled={true}
                                onChange={(v) => {
                                    toast(t('Upcoming Feature: Monthly frequency option will be available soon.'), { duration: 3000 })
                                    trackEvent('measurement_configure_frequency_selected', { experiment_literal: undefined, frequency: 'monthly' })
                                }}
                            />
                            <label
                                htmlFor="m-date-monthly"
                                className={`group relative cursor-default block leading-[1.667rem] text-[0.667rem] font-semibold px-1 rounded-[0.333rem]  peer-checked:bg-primary ${required ? 'text-gray-900 cursor-pointer' : 'text-gray-500'}`}
                            >
                                {t('Monthly')}{' '}
                                <sup className=" bg-slate-700 rounded-sm leading-[1.4] text-white absolute left-[1rem] opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap top-[0rem] px-1 text-[0.4rem] font-normal">Coming Soon</sup>
                            </label>
                        </>
                    )}
                />
            </div>
        </div>
    )
}

interface MeasurementConfigureProps {
    prev: () => void
    type: 'RCT' | 'OSTUDY'
    recurring_experiment?: any
    recurringConfig?: any
    createRecurringExperiment?: (payload: any) => void
}

const MeasurementConfigure: React.FC<MeasurementConfigureProps> = ({ prev, type, recurring_experiment, recurringConfig, createRecurringExperiment }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { confirm } = useConfirmDialog()
    const params = useParams()
    const dataTableGrid = useRef<AgGridReact>(null)
    const exp = useExperimentSelector()
    const [experiment, setExperiment] = useState<any>(null)
    const conmmonApi = useCommonApi()
    const experimentApi = useExperimentApi()
    const [rowData, setRowData] = useState<[]>([])
    const [columnDefs, setcolumnDefs] = useState<[]>([])
    const { showLoader, hideLoader } = useFpLoader()
    const [columns, setColumns] = useState<any>(null)
    const [kpiInterests, setKpiInterests] = useState<any[]>([])
    const [mdata, setMdata] = useState<any>(null)
    const [dateCols, setDateCols] = useState<any>(null)
    const [granularity, setGranularity] = useState<any>(null)
    const [working, setWorking] = useState<boolean>(false)
    const [groupConfigsReady, setGroupConfigsReady] = useState<boolean>(false)

    const measurementSuccessModalRef: any = useRef()
    const [kpiColumns, setKpiColumns] = useState<any[]>([])
    const [dataCalled, setDataCalled] = useState<boolean>(false)
    const dialog = useDialog()
    const [designBlockingFactors, setDesignBlockingFactors] = useState<any[]>([])
    const [matchedBlockingFactors, setMatchedBlockingFactors] = useState<any[]>([])
    const { confirm: confirmDialog } = useDialog()
    const measurementHookFunction = useMeasurementConfigure({ experimentType: type })
    const showGrid = experiment?.experiment_type['title'] == 'Post-Treatment Comparison' ? 'grid-cols-2' : 'grid-cols-3'

    const {
        control,
        getValues,
        watch,
        trigger,
        setValue,
        formState: { errors, isDirty },
    } = useForm<any>({
        defaultValues: { metrics: [], groupConfigs: [] },
    })

    const {
        fields: metricFields,
        append: metricAppend,
        remove: metricRemove,
    } = useFieldArray({
        control,
        name: 'metrics',
    })

    const {
        fields: groupConfigs,
        append: groupConfigAppend,
        update: groupConfigUpdate,
        remove: groupConfigsRemove,
    } = useFieldArray({
        control,
        name: 'groupConfigs',
    })

    const groupConfigsWatch = watch('groupConfigs')
    const metricsWatch = watch('metrics')
    const granularityWatch = watch('_name1')
    const name3Watch = watch('_name3')
    const blockingFactorsWatch = watch('blockingFactors')

    const getColumnsResponseHandeler = (resp: any) => {
        return new Promise((resolve, reject) => {
            let allColumns: any[] = []
            for (const arr of Object.values(resp.data)) {
                allColumns = [...allColumns, ...(arr as any)]
            }
            const uarr: any[] = []
            for (const str of allColumns) {
                if (!uarr.includes(str)) {
                    uarr.push(str)
                }
            }
            const _columns: any = {}
            const missingValuesCols: string[] = resp.data.missing_values_column ?? []
            resp.data['datetime_columns'] = (resp.data['datetime_columns'] ?? []).filter((col: string) => !missingValuesCols.includes(col))

            for (const key of Object.keys(resp.data)) {
                _columns[key as DistributionColumnNameType] = resp.data[key].map((name: any) => {
                    return {
                        label: name,
                        value: name,
                    }
                })
            }

            setDateCols([..._columns.datetime_columns])

            const options = [..._columns.boolean_columns, ..._columns.numeric_columns, ..._columns.string_columns, ..._columns.unique_columns]
            setGranularity(makeUniqueOptionArray(options))

            _columns.all = uarr.map((name: any) => {
                return {
                    label: name,
                    value: name,
                }
            })

            setMatchedBlockingFactors(_columns.all.filter((col: any) => experiment?.experiment_metadatas?.design_column_map?.blocking_factors?.includes(col.value)).sort((a: any, b: any) => a.label.localeCompare(b.label)))
            setColumns(_columns)
            resolve(_columns)
        })
    }

    const getColumnSuccess = (resp: any, resolve: any, reject: any) => {
        getColumnsResponseHandeler(resp)
            .then((_columns: any) => {
                resolve(_columns)
            })
            .catch((error: any) => {
                reject(new Error(error?.message || 'An unknown error occurred'))
            })
    }

    const getRecurringColumnsData = () => {
        return new Promise((resolve, reject) => {
            experimentApi.getRecurringColumnsData(
                {
                    literal: experiment?.experiment_literal,
                    ...recurringConfig,
                },
                (resp: any) => {
                    console.log('recurring XXXXXXXXXXXXXXXX columns data', resp)
                    getColumnSuccess(resp, resolve, reject)
                },
                (error: any) => {
                    reject(new Error(error?.message || 'An unknown error occurred'))
                },
            )
        })
    }

    const setcolumnPreviewData = (data: any) => {
        console.log('setting preview data', data)
    }

    const getRecurringTableData = () => {
        return new Promise((resolve, reject) => {
            experimentApi.getRecurringTableDataPreview(
                {
                    literal: experiment.experiment_literal,
                    page: 1,
                    limit: 40,
                    ...recurringConfig,
                },
                (data: any) => {
                    processDataColumnResponse(null, data.data.result, setcolumnDefs, setRowData, setcolumnPreviewData, hideLoader)
                    resolve(data.data.result)
                },
                (error: any) => {
                    hideLoader()
                    setRowData([])
                    if (error?.message) {
                        toast.error(error?.message, { duration: 10000 })
                    } else {
                        toast.error(error, { duration: 10000 })
                    }
                },
            )
        })
    }

    const getColumns = () => {
        return new Promise((resolve, reject) => {
            experimentApi.getColumnsForGroupDristribution(
                {
                    literal: experiment.experiment_literal,
                    tableType: 'KPI',
                },
                (resp: any) => {
                    getColumnSuccess(resp, resolve, reject)
                },
                (error: any) => {
                    reject(new Error(error?.message || 'An unknown error occurred'))
                },
            )
        })
    }

    const createColumnDes = (data: any) => {
        return data.map((key: any, i: number) => {
            return {
                headerName: key,
                field: key,
                filter: false,
                sortable: false,
                suppressMenu: true,
                cellStyle: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                cellRenderer,
            }
        })
    }

    const getTableData = () => {
        return new Promise((resolve, reject) => {
            measurementHookFunction
                .getTableData(experiment)
                .then((data: any) => {
                    const columnDefs: any = createColumnDes(Object.keys(data[0]))
                    setcolumnDefs(columnDefs)
                    setRowData(data)
                    resolve(data)
                })
                .catch((error: any) => {
                    reject(new Error(error?.message || 'An unknown error occurred'))
                })
        })
    }

    const getKpiTypes = () => {
        conmmonApi.getKpiTypes(
            { sort_by: '-created_at', page: 1, per_page: 10 },
            (data: any) => {
                const interests = [...data.data.result]?.map((kpi: any) => {
                    kpi.label = kpi.name
                    kpi.value = kpi.kpi_literal
                    return kpi
                })

                setKpiInterests(interests)
            },
            (error: ErrorResponse<BusinessFunctionDataType>) => {
                toast.error(error.message)
            },
        )
    }

    const execute = () => {
        measurementHookFunction.executeMeasurement(experiment.experiment_literal).catch((error: any) => {
            setWorking(false)
        })
    }

    const updateMuserementExperiment = (payload: any) => {
        setWorking(true)
        experimentApi.updateExperiment(
            payload,
            (resp: any) => {
                updateExperimentResponseHandler_forWeekly(resp)
                experimentApi.executedesignmergeoverview(
                    { literal: experiment?.experiment_literal },
                    (resp: any) => {
                        execute()
                    },
                    (error: any) => {
                        setWorking(false)
                    },
                )
            },
            (error: any) => {
                setWorking(false)
                showExperimentUpdateError(error)
            },
        )
    }

    const updateEXP = () => {
        experimentApi.executedesignmergeoverview(
            { literal: experiment?.experiment_literal },
            (resp: any) => {
                setWorking(false)
                setMdata(resp)
                measurementSuccessModalRef?.current?.showModal()
            },
            (error: any) => {
                setWorking(false)
            },
        )
    }

    const createDesignPlusMeasurementConfigurePayload = () => {
        const DATA: any = getValues()
        const payload: any = {
            literal: experiment?.experiment_literal,
            step: 5,
            is_draft: true,
            measurement_column_map: {
                granularity: DATA._name1?.value,
                date: DATA?._name2?.value,
                allocation_group: DATA?._name3?.value ?? '',
                date_frequency: DATA.frequency,
                kpi: DATA.metrics.map((kpi: any) => {
                    const kpidata = {
                        ...kpi,
                        column_map: kpi.column_map.value,
                    }
                    delete kpidata.id
                    return kpidata
                }),
            },
            submit_from: 'measurement_configuration',
        }

        let is_blocking_factors_change: boolean = false

        if (experiment?.experiment_metadatas?.design_column_map?.blocking_factors) {
            for (const factor of experiment.experiment_metadatas.design_column_map.blocking_factors) {
                let found = false
                for (const option of DATA.blockingFactors) {
                    if (option.value === factor) {
                        found = true
                    }
                }
                if (!found) {
                    is_blocking_factors_change = true
                }
            }
        }

        if (is_blocking_factors_change) {
            payload.design_blocking_factors_overwrite = DATA.blockingFactors.map((option: any) => option.value)
        } else {
            payload.measurement_column_map.blocking_factors = DATA.blockingFactors?.map((option: any) => option.value)
        }

        console.log('payload ~~~~~~~~~~~~~~~~', payload)
        return payload
    }

    const updateExperiment = (payload: any) => {
        setWorking(true)
        experimentApi.updateExperiment(
            payload,
            (resp: any) => {
                updateExperimentResponseHandler_forWeekly(resp)
                experimentApi.getExperimentDetails(
                    { literal: experiment?.experiment_literal + '?use_orm=true' },
                    (respexp: any) => {
                        if (respexp?.data?.experiment_metadatas?.measurement_data_quality_report?.measurement_data_validation?.can_continue_flow === false) {
                            hideLoader()
                            toast.error(respexp?.data?.experiment_metadatas?.measurement_data_quality_report?.measurement_data_validation?.errors[0], {
                                duration: 10000,
                            })

                            setWorking(false)
                            return false
                        }
                        updateEXP()
                    },
                    (error: any) => {},
                )
            },
            (error: any) => {
                setWorking(false)
                showExperimentUpdateError(error)
            },
        )
    }

    const RCT_GroupValidation = (resp: any) => {
        if (resp.data.groups?.length < 2 || resp.data.groups?.length > 5) {
            dialog.confirm({
                type: 'delete',
                title: t('Validation Error'),
                message: t('you should not have more than 5 groups or less that 2 groups'),
                confirmButtonLabel: t('Ok'),
                cancelButton: false,
                onConfirm: () => {},
            })
        } else {
            setGroupConfigsReady(true)
            groupConfigsRemove()
            const prevGroupConfig = experiment?.experiment_metadatas?.group_configs
            resp.data.groups.map((group: any, i: number) => {
                const prevGroup: any = prevGroupConfig?.find((g: any) => g.name === group.name)
                groupConfigAppend({
                    name: group.name,
                    action: prevGroup ? prevGroup.action : '',
                    isControl: prevGroup ? prevGroup.is_control : false,
                    distribution: group.size / (resp.data.total_size / 100),
                    size: group.size,
                })
            })
        }
    }

    const OSTUDY_GroupValidation = (resp: any) => {
        if (resp.data.groups?.length == 2) {
            const allHaveNames = resp.data.groups.every((group: any) => group?.name)
            if (allHaveNames) {
                setGroupConfigsReady(true)
                groupConfigsRemove()
                const prevGroupConfig = experiment?.experiment_metadatas?.group_configs
                resp.data.groups.map((group: any, i: number) => {
                    const prevGroup: any = prevGroupConfig?.find((g: any) => g.name === group.name)
                    groupConfigAppend({
                        name: group.name,
                        action: prevGroup ? prevGroup.action : '',
                        isControl: prevGroup ? prevGroup.is_control : false,
                        distribution: group.size / (resp.data.total_size / 100),
                        size: group.size,
                    })
                })
            } else {
                confirmDialog({
                    type: 'delete',
                    title: t('Validation Error'),
                    message: t('Your file contains null values in the group column. Please review the data and re-upload with valid Test and Control groups'),
                    confirmButtonLabel: t('Ok'),
                    cancelButton: false,
                    onConfirm: () => {},
                })
            }
        } else {
            const allHaveNames = resp.data.groups.every((group: any) => group?.name)
            if (allHaveNames) {
                dialog.confirm({
                    type: 'delete',
                    title: t('Validation Error'),
                    message: t('Only 2 groups are allowed. Your file contains more than 2 groups — please update your data accordingly.'),
                    confirmButtonLabel: t('Ok'),
                    cancelButton: false,
                    onConfirm: () => {},
                })
            } else {
                confirmDialog({
                    type: 'delete',
                    title: t('Validation Error'),
                    message: t('Your file contains null values in the group column. Please review the data and re-upload with valid Test and Control groups'),
                    confirmButtonLabel: t('Ok'),
                    cancelButton: false,
                    onConfirm: () => {},
                })
            }
        }
    }

    const weeklyConfig: any = useRef(null)

    const GetDistributionData = () => {
        experimentApi.GetMeasurementGroupDistributionData(
            { literal: experiment?.experiment_literal },
            (resp: any) => {
                setWorking(false)
                if (resp.data.groups && resp.data.total_size) {
                    if (experiment?.experiment_type?.title === EXPERIMENT_TYPES.OBS.title) {
                        OSTUDY_GroupValidation(resp)
                    } else {
                        RCT_GroupValidation(resp)
                    }
                } else {
                    console.log('did not get proper response from API')
                }
            },
            (error: any) => {
                setWorking(false)
                dialog.confirm({
                    type: 'delete',
                    title: t('ERROR'),
                    message: error?.message,
                    confirmButtonLabel: t('Ok'),
                    cancelButton: false,
                    onConfirm: () => {},
                })
                //toast.error(error?.message)
            },
        )
    }

    const createMeasurementColumnMapPayload = () => {
        const DATA: any = getValues()
        return {
            granularity: DATA._name1.value,
            date: DATA?._name2?.value,
            allocation_group: DATA._name3?.value,
            blocking_factors: DATA.blockingFactors?.map((option: any) => option.value),
            date_frequency: DATA.frequency,
            kpi: DATA.metrics.map((kpi: any) => {
                const kpidata = {
                    ...kpi,
                    column_map: kpi.column_map.value,
                }
                delete kpidata.id
                return kpidata
            }),
        }
    }

    const GetRecurringMeasurementGroupDistributionData = () => {
        setWorking(true)
        experimentApi.GetRecurringMeasurementGroupDistributionData(
            { literal: experiment.experiment_literal, ...recurringConfig, measurement_column_map: createMeasurementColumnMapPayload() },
            (resp: any) => {
                setWorking(false)
                if (resp.data.groups && resp.data.total_size) {
                    if (experiment?.experiment_type?.title === EXPERIMENT_TYPES.OBS.title) {
                        OSTUDY_GroupValidation(resp)
                    } else {
                        RCT_GroupValidation(resp)
                    }
                } else {
                    console.log('did not get proper response from API')
                }
            },
            (error: any) => {
                setWorking(false)
                toast.error(error?.message)
            },
        )
    }

    const resetMeasurementColumnMap = () => {
        const payload: any = {
            literal: experiment?.experiment_literal,
            step: 5,
            is_draft: true,
            measurement_column_map: null,
        }

        experimentApi.updateExperiment(
            payload,
            (resp: any) => {
                void navigate(URLS.MEASUREMENT(experiment?.experiment_literal, 'data'))
            },
            (error: any) => {
                setWorking(false)
                showExperimentUpdateError(error)
            },
        )
    }

    const updateExperimentResponseHandler_forWeekly = (resp: any) => {
        if (resp.data.weekly_message?.warning_msg) {
            void confirm({
                type: 'info',
                title: 'Confirm Data Coverage Before Proceeding',
                message: (
                    <div className="text-[0.61rem] text-[#000000] leading-[1.3] text-start">
                        <p className="font-medium">Message</p>
                        <p className="mb-2">{resp.data.weekly_message?.warning_msg}</p>
                        <p>
                            <span className="font-medium">Baseline Period:</span> {moment(`${resp.data.weekly_message?.baseline_start_date}`).format('YYYY-MM-DD')} to {moment(`${resp.data.weekly_message?.baseline_end_date}`).format('YYYY-MM-DD')}
                        </p>
                        <p>
                            <span className="font-medium mb-2">Analysis Period:</span> {moment(`${resp.data.weekly_message?.analysis_start_date}`).format('YYYY-MM-DD')} to{' '}
                            {moment(`${resp.data.weekly_message?.analysis_end_date}`).format('YYYY-MM-DD')}
                        </p>

                        <p className="mb-2 mt-2">These periods were determined from the actual data available in the file and may differ from the originally configured date ranges.</p>
                        <p className="font-medium">Note</p>
                        <p>⚠️ Please confirm that these detected periods are acceptable for your analysis. To ensure accurate results, verify that:</p>
                        <ul className="list-disc list-inside text-[0.547rem] text-[#000000] leading-[1.3] my-2">
                            <li>The baseline and analysis periods are complete.</li>
                            <li>There is no overlap between the periods.</li>
                            <li>If the detected coverage is not suitable, update the dataset and re-upload it.</li>
                        </ul>
                        <p>If the detected coverage is not suitable, update the dataset and re-upload it.</p>
                    </div>
                ),
                buttons: {
                    Cancel: { label: 'Review Data & Re-upload', variant: 'secondary', action: resetMeasurementColumnMap },
                    Continue: { label: 'Proceed with Analysis', variant: 'primary' },
                },
            })

            weeklyConfig.current = {
                baseline_start_week: resp.data.weekly_message?.baseline_start_date,
                baseline_end_week: resp.data.weekly_message?.baseline_end_date,
                analysis_start_week: resp.data.weekly_message?.analysis_start_date,
                analysis_end_week: resp.data.weekly_message?.analysis_end_date,
            }
        }
    }

    const showExperimentUpdateError = (error: any) => {
        if (error.error && Object.keys(error.error).length > 0) {
            const buttons: any = {}
            if (error.error?.buttons.length > 0) {
                error.error?.buttons.forEach((button: any) => {
                    buttons[button.button_text] = { label: button.button_text, variant: button.button_type === 'cancel' ? 'secondary' : 'primary' }
                })
            } else {
                buttons['Cancel'] = { label: 'Cancel', variant: 'secondary' }
            }

            void confirm({
                type: 'error',
                title: error.error.title || 'Configuration Error!',
                message: <Md className="!text-[0.6rem]" text={error?.error?.message || error?.message || 'An unknown error occurred'} />,
                buttons,
            })
        } else {
            void confirm({
                type: 'error',
                title: 'Configuration Error!',
                message: error?.message || 'An unknown error occurred',
                buttons: {
                    Cancel: { label: 'Cancel', variant: 'secondary' },
                },
            })
        }
    }

    const GetMeasurementGroupDistributionData = () => {
        const payload: any = {
            literal: experiment?.experiment_literal,
            step: 5,
            is_draft: true,
            measurement_column_map: createMeasurementColumnMapPayload(),
            submit_from: 'measurement_configuration',
        }

        setWorking(true)
        experimentApi.updateExperiment(
            payload,
            (resp: any) => {
                if (resp.message.search(/Renamed/i) !== -1) {
                    toast.success(resp.message)
                }

                updateExperimentResponseHandler_forWeekly(resp)

                experimentApi.getExperimentDetails(
                    { literal: experiment?.experiment_literal + '?use_orm=true' },
                    (respexp: any) => {
                        if (respexp?.data?.experiment_metadatas?.measurement_data_quality_report?.measurement_data_validation?.can_continue_flow === false) {
                            hideLoader()
                            toast.error(respexp?.data?.experiment_metadatas?.measurement_data_quality_report?.measurement_data_validation?.errors[0], {
                                duration: 10000,
                            })

                            setWorking(false)
                            return false
                        }

                        GetDistributionData()
                    },
                    (error: any) => {},
                )
            },
            (error: any) => {
                setWorking(false)
                showExperimentUpdateError(error)
            },
        )
    }

    const getOptionsSelected = () => {
        let a: any = []
        if (granularityWatch) {
            a.push(granularityWatch)
        }
        if (name3Watch) {
            a = [...a, name3Watch]
        }
        if (blockingFactorsWatch && blockingFactorsWatch.length > 0) {
            a = [...a, ...blockingFactorsWatch]
        }

        if (metricsWatch && metricsWatch.length > 0) {
            for (const item of metricsWatch) {
                if (item.column_map?.value) {
                    a.push(item.column_map)
                }
            }
        }
        return a
    }

    const isDefaultKPI = (kpi: string) => {
        const found: any = kpiInterests.filter((metrix: any) => {
            return metrix.name?.toLowerCase() == kpi.toLowerCase()
        })
        return found.length > 0
    }

    const getBlockingFactorsOptions = (availableOptions: any) => {
        if (experiment?.is_measurement_flow) {
            return filteredOption(availableOptions, [], getOptionsSelected())
        }
        return name3Watch ? matchedBlockingFactors : designBlockingFactors || []
    }

    const getGroupConfigs = () => {
        return (
            <>
                {groupConfigs?.map((group: any, i: any) => (
                    <div className="grid grid-cols-9 gap-2 mb-2 " key={`group-${group.id}`}>
                        {GroupName(group, i, control, trigger, errors, t)}
                        {isControl(control, i, groupConfigsWatch, groupConfigUpdate)}
                        <div className="col-span-3 bg-[#f4f4f4] border border-[#d4d4d4] rounded-[0.3rem] p-1 grid grid-cols-3 gap-2 items-center">
                            <div className="col-span-2">
                                <Text size="md" className="pl-1 font-semibold flex-grow">
                                    {group?.distribution?.toFixed(2)}%
                                </Text>
                            </div>
                            <div className="flex items-center">
                                <Text size="md" className="pl-1 font-semibold flex-grow">
                                    {group.size}
                                </Text>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    const metricsColumnMapOnChage = (value: any, kpi: any, onChange: any, i: number) => {
        if (isDefaultKPI(kpi.literral_value)) {
            if (kpi.literral_value.toLowerCase() != value.label.toLowerCase() && columns.numeric_columns.map((col: any) => col.label.toLowerCase()).includes(kpi.literral_value.toLowerCase())) {
                //warning --
                dialog.confirm({
                    type: 'delete',
                    title: t('Warning: Mismatch Identified'),
                    message: t('You have mapped <b>{{mappedColumn}}</b> for KPI <b>{{kpiName}}</b>, We found <b>{{suggestedColumn}}</b> another column which could be more relavent.', {
                        mappedColumn: value.label,
                        kpiName: kpi.literral_value,
                        suggestedColumn: kpi.literral_value,
                    }),
                    warning: t('The results might become inaccurate if you proceed this way'),
                    confirmButtonLabel: t('Yes Proceed'),
                    onConfirm: () => {
                        onChange(value)
                        void trigger(`metrics.${i}`)
                        trackEvent('measurement_configure_kpi_mismatch_confirmed', { experiment_literal: experiment?.experiment_literal })
                    },
                    onCancel: () => {
                        console.log('No')
                        trackEvent('measurement_configure_kpi_mismatch_cancelled', { experiment_literal: experiment?.experiment_literal })
                    },
                })
            } else if (kpiColumns.filter((_kpi: any) => _kpi != kpi.literral_value.toLowerCase()).includes(value.label.toLowerCase())) {
                dialog.confirm({
                    type: 'delete',
                    title: t('Warning: Mismatch Identified'),
                    message: t('You have mapped <b>{{mappedColumn}}</b> for KPI <b>{{kpiName}}</b>, We found <b>{{suggestedColumn}}</b> could be more relavent with KPI <b>{{suggestedColumn}}</b>.', {
                        mappedColumn: value.label,
                        kpiName: kpi.literral_value,
                        suggestedColumn: value.label,
                    }),
                    warning: t('The results might become inaccurate if you proceed this way'),
                    confirmButtonLabel: t('Yes Proceed'),
                    onConfirm: () => {
                        onChange(value)
                        void trigger(`metrics.${i}`)
                        trackEvent('measurement_configure_kpi_mismatch_confirmed', { experiment_literal: experiment?.experiment_literal })
                    },
                    onCancel: () => {
                        console.log('No')
                        trackEvent('measurement_configure_kpi_mismatch_cancelled', { experiment_literal: experiment?.experiment_literal })
                    },
                })
            } else {
                onChange(value)
                void trigger(`metrics.${i}`)
            }
        } else {
            onChange(value)
            void trigger(`metrics.${i}`)
        }
    }

    const prefillBlockingFactors = () => {
        const designBlockingFactorsOptions = experiment?.experiment_metadatas?.design_column_map?.blocking_factors
            .map((colName: string) => {
                return {
                    label: colName,
                    value: colName,
                }
            })
            .sort((a: any, b: any) => a.label.localeCompare(b.label))

        setDesignBlockingFactors(designBlockingFactorsOptions)

        if (experiment?.experiment_metadatas?.measurement_column_map?.date_frequency == 'weekly') {
            const columnMap: any = experiment?.experiment_metadatas?.measurement_column_map
            weeklyConfig.current = {
                baseline_start_week: columnMap?.baseline_start_week,
                baseline_end_week: columnMap?.baseline_end_week,
                analysis_start_week: columnMap?.analysis_start_week,
                analysis_end_week: columnMap?.analysis_end_week,
            }
        }

        if (experiment?.experiment_metadatas?.measurement_column_map?.blocking_factors) {
            const blockingFactorsOptions = experiment?.experiment_metadatas?.measurement_column_map?.blocking_factors.map((colName: string) => {
                return {
                    label: colName,
                    value: colName,
                }
            })
            if (columns?.string_columns) {
                setTimeout(() => {
                    setValue('blockingFactors', blockingFactorsOptions)
                }, 500)
            }
        } else if (experiment?.experiment_metadatas?.design_column_map?.blocking_factors && !experiment?.is_measurement_flow) {
            setValue('blockingFactors', designBlockingFactorsOptions)
        }
    }

    useEffect(() => {
        if (experiment?.experiment_metadatas?.metrices && columns) {
            metricRemove()
            setKpiColumns(
                experiment?.experiment_metadatas?.metrices.map((kpi: any) => {
                    return kpi.literral_value.toLowerCase()
                }),
            )

            const Options: any = [...(columns?.numeric_columns || []), ...(columns?.boolean_columns || [])]

            if (experiment?.experiment_metadatas?.measurement_column_map?.kpi && experiment?.experiment_metadatas?.measurement_column_map?.kpi.length > 0) {
                experiment?.experiment_metadatas?.measurement_column_map.kpi.map((kpi: any) => {
                    metricAppend({ ...kpi, column_map: getSelectedOption(kpi.column_map, Options) })
                })
            } else {
                experiment?.experiment_metadatas?.metrices.map((kpi: any) => {
                    metricAppend(kpi)
                })
            }
        }

        if (!recurringConfig && experiment?.experiment_metadatas?.measurement_column_map?.kpi && experiment?.experiment_metadatas?.group_configs?.length > 0 && !groupConfigsReady && experiment?.is_measurement_flow) {
            setGroupConfigsReady(true)
            GetDistributionData()
        }

        if (!dataCalled && experiment) {
            if (recurring_experiment) {
                showLoader()
                setDataCalled(true)
                Promise.all([getRecurringColumnsData(), getRecurringTableData()])
                    .then((values: any) => {
                        setTimeout(hideLoader, 1200)
                    })
                    .catch((error: any) => {
                        hideLoader()
                        toast.error(error?.message || t('Error fetching measurement data'))
                    })
            } else if (experiment?.data_mappings?.delta_measurement_table_name || experiment?.data_mappings?.user_created_measurement_table_name) {
                showLoader()
                setDataCalled(true)
                Promise.all([getColumns(), getTableData()])
                    .then((values: any) => {
                        setTimeout(hideLoader, 1200)
                    })
                    .catch((error: any) => {
                        hideLoader()
                        toast.error(error?.message || t('Error fetching measurement data'))
                    })
            }
        }
    }, [experiment, columns])

    useEffect(() => {
        if (granularity && experiment && dateCols && columns) {
            console.log('prefill form values - xxxxxxxxxxxx -', experiment?.experiment_metadatas?.measurement_column_map)
            if (experiment?.experiment_metadatas?.measurement_column_map?.granularity) {
                setValue('_name1', getSelectedOption(experiment?.experiment_metadatas?.measurement_column_map?.granularity, granularity))
                setValue('_name3', getSelectedOption(experiment?.experiment_metadatas?.measurement_column_map?.allocation_group, columns ? columns.string_columns : []))
                /*  if (experiment?.experiment_type?.title != EXPERIMENT_TYPES.OBS.title) {
                     console.log('Not OBS - xxxxxxxxxxxx -', experiment?.experiment_metadatas?.measurement_column_map?.date, dateCols)
                     setValue('_name2', getSelectedOption(experiment?.experiment_metadatas?.measurement_column_map?.date, dateCols || []))

                 } else {
                     console.log('OBS - xxxxxxxxxxxx -', experiment?.experiment_metadatas?.measurement_column_map?.date, dateCols)
                 } */
                setValue('_name2', getSelectedOption(experiment?.experiment_metadatas?.measurement_column_map?.date, dateCols || []))
                setValue('frequency', experiment?.experiment_metadatas?.measurement_column_map?.date_frequency)

                //setValue('blockingFactors', matchedBlockingFactors);
            }
            prefillBlockingFactors()
        }
    }, [granularity, experiment, dateCols, columns])

    useEffect(() => {
        if (recurring_experiment) {
            setExperiment(recurring_experiment)
        } else if (exp?.experiment_literal == params?.experiment) {
            setExperiment(exp)
        }
    }, [recurring_experiment, exp])

    useEffect(() => {
        getKpiTypes()
    }, [])

    const updatePayloadWithWeeklyConfig = (payload: any) => {
        if (weeklyConfig.current) {
            return { ...payload, submit_from: 'measurement_configuration', measurement_column_map: { ...(payload.measurement_column_map ? payload.measurement_column_map : {}), ...(weeklyConfig.current ? weeklyConfig.current : {}) } }
        }
        return payload
    }

    return (
        <Container size="md">
            <div className="shadow-1 rounded-[0.833rem] p-5">
                <div className="w-full">
                    <div className="flex items-center justify-between">
                        <div className="relative flex items-center gap-2">
                            <div className="absolute -left-5 top-0 h-full w-2 bg-primary rounded-e-md"></div>
                            <P className="!mb-0 font-semibold">{experiment?.experiment_name}</P>
                        </div>
                    </div>
                    <div className="flex items-center justify-between mb-3 ">
                        <p className="font-bold text-start text-[1.125rem] leading-8">{t('Measurement Data')}</p>
                        <MatchingParameter experiment={experiment?.experiment_literal} type={type} />
                    </div>
                    <Text size="md" className="mt-2">
                        {t('Map your data')}
                    </Text>

                    <div className={`grid ${showGrid} gap-3`}>
                        <div>
                            <Text size="md" className="text-black font-medium">
                                {t('Select Granularity')}
                            </Text>
                            <Text size="md" className="text-[#464E5F] mb-2 italic">
                                {t('Please select the column which represents the Granularity')} <span className="text-red-500">*</span>
                            </Text>
                        </div>

                        <div>
                            <Text size="md" className="text-black font-medium">
                                {t('Select Grouping Column')}
                            </Text>
                            <Text size="md" className="text-[#464E5F] mb-2">
                                {t('Select the column that maps Test and Control groups at the chosen granularity.')} {experiment?.is_measurement_flow ? <span className="text-red-500">*</span> : null}
                            </Text>
                        </div>
                        {experiment?.experiment_type['title'] != 'Post-Treatment Comparison' && (
                            <div>
                                <Text size="md" className="text-black font-medium">
                                    {t('Select Date')}
                                </Text>
                                <Text size="md" className="text-[#464E5F] mb-2">
                                    {t('Please select the column which represents the date')} <span className="text-red-500">*</span>
                                </Text>
                            </div>
                        )}
                    </div>
                    <div className={`grid ${showGrid} gap-3`}>
                        <div>
                            <Controller
                                name="_name1"
                                control={control}
                                rules={{ required: t('Please select') }}
                                render={({ field: { value, onChange } }) => (
                                    <Dropdown
                                        disabled={!!recurring_experiment}
                                        value={value}
                                        onChange={(value: any) => {
                                            onChange(value)
                                            void trigger('_name1')
                                            trackEvent('measurement_configure_granularity_selected', { experiment_literal: experiment?.experiment_literal, column_name: value?.label })
                                        }}
                                        options={filteredOption(granularity ?? [], [], getOptionsSelected())}
                                        error={errors?._name1?.message as string}
                                    />
                                )}
                            />

                            <FieldValidation />
                        </div>

                        <div>
                            <Controller
                                name="_name3"
                                control={control}
                                rules={{
                                    required: experiment?.is_measurement_flow ? t('Please select Grouping Column') : false,
                                }}
                                render={({ field: { value, onChange } }) => (
                                    <Dropdown
                                        disabled={!!recurring_experiment}
                                        value={value}
                                        isClearable
                                        onChange={(value: any) => {
                                            if (value) {
                                                setValue('blockingFactors', matchedBlockingFactors)
                                            } else {
                                                setValue('blockingFactors', designBlockingFactors)
                                            }
                                            onChange(value)
                                            void trigger(['blockingFactors', '_name3'])
                                            trackEvent('measurement_configure_grouping_selected', { experiment_literal: experiment?.experiment_literal, column_name: value?.label })
                                        }}
                                        options={filteredOption(columns ? makeUniqueOptionArray([...columns.string_columns]) : [], [], getOptionsSelected())}
                                        error={errors?._name3?.message as string}
                                    />
                                )}
                            />

                            <FieldValidation />
                        </div>
                        {experiment?.experiment_type['title'] != 'Post-Treatment Comparison' && (
                            <div>
                                <Controller
                                    name="_name2"
                                    control={control}
                                    rules={{ required: t('Please select') }}
                                    render={({ field: { value, onChange } }) => (
                                        <Dropdown
                                            disabled={!!recurring_experiment}
                                            value={value}
                                            onChange={(value: any) => {
                                                onChange(value)
                                                void trigger('_name2')
                                                trackEvent('measurement_configure_date_selected', { experiment_literal: experiment?.experiment_literal, column_name: value?.label })
                                            }}
                                            options={sortOptions(dateCols) || []}
                                            error={errors?._name2?.message as string}
                                        />
                                    )}
                                />

                                <div className="bg-[#FAF8EF] border border-[#0AD4E133] rounded-[0.45rem] mt-2">
                                    <Text size="lg" className="font-semibold p-2">
                                        {t('Validation:')} {t('No Missing Values')}
                                    </Text>
                                    <div className="border-b border-[#0AD4E133]"></div>
                                    <div className={`flex items-center justify-between p-1 ${recurring_experiment ? 'pointer-events-none' : ''}`}>
                                        {metricFields?.length && (metricFields[0] as any).literral_value != 'Total Distribution' ? (
                                            <>
                                                <Text size="md" className="!leading-none">
                                                    {t('Select Time Granularity')}
                                                </Text>
                                                {DateFrequency(control, trigger, metricFields, t)}
                                            </>
                                        ) : (
                                            <div className="h-6"></div>
                                        )}
                                    </div>
                                    <div className="flex justify-end">{errors?.frequency?.message ? <p className="text-error text-[.542rem] mt-1">{errors?.frequency?.message as string}</p> : null}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mt-4 grid grid-cols-2 gap-3">
                        <div>
                            <div>
                                <Text size="md" className="text-black font-medium">
                                    {t('Select KPIs Column')}
                                </Text>
                                <Text size="md" className="text-[#464E5F] mb-2 italic">
                                    {t('The columns which represent the primary and other KPIs on which you want to execute Measurement. Please ensure to select the relevant numerical columns only.')} <span className="text-red-500">*</span>
                                </Text>
                            </div>

                            {kpiInterests && (
                                <>
                                    {metricFields.map((kpi: any, i: number) => {
                                        const Options: any = [...(columns?.numeric_columns ?? []), ...(columns?.boolean_columns ?? [])]

                                        const selectedOptions = metricsWatch?.map((item: any) => item.column_map)
                                        const availableOptions = sortOptions(
                                            Options.filter((opt: any) => {
                                                let used = false
                                                selectedOptions.map((_selected: any) => {
                                                    if (metricsWatch[i].column_map?.value != opt?.value) {
                                                        if (_selected?.value == opt?.value) {
                                                            used = true
                                                        }
                                                    }
                                                })
                                                return !used
                                            }),
                                        )

                                        return (
                                            <div key={`kpi-${i.toString()}`} className="grid grid-cols-2 gap-2 mb-2">
                                                <CommonInputText value={kpi?.literral_value} disabled={true} />
                                                <Controller
                                                    name={`metrics.${i}.column_map`}
                                                    control={control}
                                                    rules={{
                                                        required: t('Please select'),
                                                    }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <Dropdown
                                                            disabled={!!recurring_experiment}
                                                            value={value}
                                                            isClearable={true}
                                                            onChange={(value: any) => {
                                                                metricsColumnMapOnChage(value, kpi, onChange, i)
                                                                trackEvent('measurement_configure_kpi_mapped', { experiment_literal: experiment?.experiment_literal, column_name: value?.label })
                                                            }}
                                                            options={filteredOption(availableOptions, [], getOptionsSelected())}
                                                            error={(errors?.metrics as any)?.[i]?.column_map?.message as string}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        )
                                    })}
                                </>
                            )}
                        </div>

                        <div>
                            <Text size="md" className="text-black font-medium">
                                {t('Select Blocking Factor (Max 5)')}
                            </Text>
                            <Text size="md" className="text-[#464E5F] mb-2">
                                {t('These are factors which can bias the result. Ex: If expt. is a marketing campaign, customer Demographic must be equally distributed in the AB test.')}
                                <br />
                            </Text>
                            <div>
                                <Controller
                                    name="blockingFactors"
                                    control={control}
                                    rules={{
                                        required: false,
                                    }}
                                    render={({ field: { value, onChange } }) => {
                                        const options = columns ? makeUniqueOptionArray([...columns.string_columns]) : []
                                        const selectedOptions = granularityWatch ? [granularityWatch] : []
                                        const availableOptions = sortOptions(
                                            options.filter((opt) => {
                                                let used = false
                                                for (const _selected of selectedOptions) {
                                                    if (_selected?.value == opt?.value) {
                                                        used = true
                                                    }
                                                }
                                                return !used
                                            }),
                                        )
                                        return (
                                            <Dropdown
                                                disabled={!!recurring_experiment}
                                                value={value}
                                                isClearable
                                                max={5}
                                                isMulti
                                                onChange={(value: any) => {
                                                    onChange(value)
                                                    void trigger(['blockingFactors', '_name3'])
                                                    trackEvent('measurement_configure_blocking_factors_selected', { experiment_literal: experiment?.experiment_literal })
                                                }}
                                                options={getBlockingFactorsOptions(availableOptions)}
                                                error={errors?.blockingFactors?.message as string}
                                            />
                                        )
                                    }}
                                />

                                <FieldValidation />
                            </div>
                        </div>
                    </div>

                    {RCTDataTable(dataTableGrid, rowData, columnDefs)}

                    {groupConfigsReady && (
                        <div className="max-w-[40rem] mx-auto">
                            <GroupConfigHeading />
                            {getGroupConfigs()}
                        </div>
                    )}

                    <div className="flex justify-between gap-3 pt-4">
                        <div>
                            <Button
                                theme="secondary"
                                styleType="outline"
                                size="xs"
                                onClick={() => {
                                    trackEvent('measurement_configure_previous_clicked', { experiment_literal: experiment?.experiment_literal })
                                    prev()
                                }}
                                disabled={working}
                            >
                                {t('Previous Step')}
                            </Button>
                        </div>
                        <div className="flex justify-end gap-4">
                            {experiment?.is_measurement_flow ? (
                                <Button
                                    theme="secondary"
                                    size="xs"
                                    onClick={() => {
                                        trackEvent('measurement_configure_submitted', { experiment_literal: experiment?.experiment_literal })
                                        trigger()
                                            .then(() => {
                                                if (groupConfigsReady) {
                                                    const payload = measurementHookFunction.getMeasurementConfigPayload(getValues, experiment, experiment.experiment_literal)
                                                    if (payload == null) {
                                                        return
                                                    }
                                                    if (createRecurringExperiment) {
                                                        setWorking(true)
                                                        const allParams = {
                                                            ...payload,
                                                            ...recurringConfig,
                                                            literal: experiment.experiment_literal,
                                                            measurement_column_map: createMeasurementColumnMapPayload(),
                                                            submit_from: 'measurement_configuration',
                                                        }
                                                        console.log('payload for creating recurring experiment', JSON.stringify(allParams))
                                                        createRecurringExperiment(allParams)
                                                    } else {
                                                        const _newPayload = updatePayloadWithWeeklyConfig(payload)
                                                        isDirty && experiment.is_completed
                                                            ? measurementHookFunction.deleteInsightsWarning(() => updateMuserementExperiment(_newPayload), experiment.experiment_literal)
                                                            : measurementHookFunction.checkBeforeMeasurementStart(trigger, () => updateMuserementExperiment(_newPayload), experiment.experiment_literal)
                                                    }
                                                } else {
                                                    recurringConfig ? GetRecurringMeasurementGroupDistributionData() : GetMeasurementGroupDistributionData()
                                                }
                                            })
                                            .catch((error) => {
                                                console.error('Error :', error)
                                            })
                                    }}
                                    disabled={working}
                                >
                                    {working ? <Loader /> : t('Continue')}
                                </Button>
                            ) : (
                                <Button
                                    theme="secondary"
                                    size="xs"
                                    onClick={() => {
                                        trackEvent('measurement_configure_submitted', { experiment_literal: experiment?.experiment_literal })
                                        const payload: any = createDesignPlusMeasurementConfigurePayload()
                                        if (createRecurringExperiment) {
                                            const allParams = { ...payload, ...recurringConfig, literal: experiment.experiment_literal, measurement_column_map: createMeasurementColumnMapPayload(), submit_from: 'measurement_configuration' }
                                            createRecurringExperiment(allParams)
                                        } else {
                                            isDirty && experiment.is_completed
                                                ? measurementHookFunction.deleteInsightsWarning(() => updateExperiment(payload), experiment.experiment_literal)
                                                : measurementHookFunction.checkBeforeMeasurementStart(trigger, () => updateExperiment(payload), experiment.experiment_literal)
                                        }
                                    }}
                                    disabled={working}
                                >
                                    {working ? <Loader /> : t('Finalize Measurement Data')}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <MeasurementSuccessModal
                _ref={measurementSuccessModalRef}
                mdata={mdata}
                onMeasurement={() => {
                    void navigate(URLS.MY_EXPERIMENTS)
                }}
            />
        </Container>
    )
}

export default MeasurementConfigure
